"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Link_1 = __importDefault(require("@sportnet/ui/lib/Link"));

var MediaManagerImage_1 = __importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  padding: 0 ", "px;\n  grid-gap: ", "px;\n  ", " {\n    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  }\n"], ["\n  display: grid;\n  padding: 0 ", "px;\n  grid-gap: ", "px;\n  ", " {\n    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.padding;
}, function (_a) {
  var theme = _a.theme;
  return theme.grid.gutterWidth;
}, utilities_1.mb('xs'));
var WrapperPerson = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  margin: 0 auto;\n  margin-bottom: 30px;\n  ", " {\n    margin: 0;\n    margin-bottom: 30px;\n  }\n  ", " {\n    display: flex;\n    text-align: left;\n  }\n"], ["\n  text-align: center;\n  margin: 0 auto;\n  margin-bottom: 30px;\n  ", " {\n    margin: 0;\n    margin-bottom: 30px;\n  }\n  ", " {\n    display: flex;\n    text-align: left;\n  }\n"])), utilities_1.mb('m'), utilities_1.mb('xl'));
var StyledMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  ", ";\n"], ["\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  ", ";\n"])), function (_a) {
  var displayBio = _a.displayBio;
  return !displayBio && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 120px;\n      height: 120px;\n    "], ["\n      width: 120px;\n      height: 120px;\n    "])));
});
var Title = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: 300;\n  font-size: 16px;\n  color: ", ";\n"], ["\n  font-weight: 300;\n  font-size: 16px;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return utilities_1.emphasizeColor(0.3, theme.app.textColor, true);
});
var Header = styled_components_1["default"].strong(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 25px;\n"], ["\n  display: inline-block;\n  font-size: 25px;\n"])));
var Bio = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  overflow-y: hidden;\n  font-size: 14px;\n  line-height: 17px;\n"], ["\n  overflow-y: hidden;\n  font-size: 14px;\n  line-height: 17px;\n"])));
var Aside = styled_components_1["default"]('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 5px 0 15px 15px;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 5px 0 15px 15px;\n  ", ";\n"])), function (_a) {
  var displayBio = _a.displayBio;
  return !displayBio && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-top: 10px;\n    "], ["\n      margin-top: 10px;\n    "])));
});

var C = function C(_a) {
  var _b = _a.data,
      data = _b === void 0 ? {} : _b,
      renderEmpty = _a.renderEmpty;
  var persons = data.persons,
      _c = data.displayBio,
      displayBio = _c === void 0 ? true : _c;

  var renderPerson = function renderPerson(person) {
    return React.createElement(React.Fragment, null, React.createElement(StyledMediaManagerImage, {
      picture: person.picture || {},
      naturalWidth: 150,
      naturalHeight: 150,
      script: "media",
      displayBio: displayBio
    }), React.createElement(Aside, {
      displayBio: displayBio
    }, React.createElement(Header, null, person.name), person.title && React.createElement(Title, null, person.title), person.bio && displayBio && React.createElement(Bio, null, person.bio.substring(0, 250)), person.urlLink && React.createElement(Link_1["default"], {
      primary: true,
      href: person.urlLink,
      target: "_blank"
    }, "Viac")));
  };

  if (persons && persons.length > 0) {
    return React.createElement(Wrapper, null, persons.map(function (person, idx) {
      return React.createElement(WrapperPerson, {
        key: idx
      }, renderPerson(person));
    }));
  }

  if (renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('persons'));
  }

  return null;
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;